export default __webpack_public_path__ + "static/media/cw27.7f20a2e4.jpg";